export const HexagonSvg = (colorPalet, width, height, stroke) => (
  <svg width={width} height={height} viewBox="0 0 1024 1024" fill="none">
    <path
      d="M512 64l416 240v416l-416 240L96 720V304z"
      stroke={colorPalet?.primary}
      strokeWidth={stroke}
    />
  </svg>
);
